import {
  AccountRevisionEvent,
  RevisionDiffResponse,
} from 'src/models/accountRevision.models'
import { UserListModel } from 'src/models/user.models'

export const eventChanges = (
  before: RevisionDiffResponse | undefined,
  after: RevisionDiffResponse | undefined,
): AccountRevisionEvent | undefined => {
  if (before === undefined) return AccountRevisionEvent.Created
  else {
    if (before?.users && after?.users) {
      if (before.users.length > after.users.length)
        return AccountRevisionEvent.UsersRemoved
      if (after.users.length === before.users.length + 1)
        return AccountRevisionEvent.UserAdded
      if (
        before.users.length > 0 === after.users.length > 0 &&
        before.users.length === after.users.length &&
        before.users[0] !== after.users[0]
      ) {
        return AccountRevisionEvent.ChangesMade
      } else if (after.users.length > before.users.length)
        return AccountRevisionEvent.UsersAdded
    } else if (
      before.displayName !== after?.displayName ||
      before?.issuingLimitCents !== after?.issuingLimitCents ||
      before.until !== after?.until ||
      before.recurrence !== after?.recurrence ||
      before?.remainingAmountCents !== after?.remainingAmountCents ||
      before?.notes !== after?.notes
    )
      return AccountRevisionEvent.ChangesMade
    else if (before.status !== after?.status)
      return AccountRevisionEvent.Expired
  }
}

export const showNewUsers = (
  beforeUsers: UserListModel[] | undefined,
  afterUsers: UserListModel[] | undefined,
): UserListModel[] => {
  const beforeUserIds = beforeUsers?.map((user) => user.id)
  const usersAdded = afterUsers?.filter(
    (user) => !beforeUserIds?.includes(user.id),
  )
  return usersAdded ?? []
}

export const showRemovedUsers = (
  beforeUsers: UserListModel[] | undefined,
  afterUsers: UserListModel[] | undefined,
): UserListModel[] => {
  const afterUserIds = afterUsers?.map((user) => user.id)
  const usersAdded = beforeUsers?.filter(
    (user) => !afterUserIds?.includes(user.id),
  )
  return usersAdded ?? []
}
